import { signInAnonymously, User } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

import { firebaseConfig } from '../../config';
import { API_URL } from '../constants/env'
import { UserProfile } from '../types/user'

// Check if any Firebase apps have been initialized
let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig); // Initialize with your Firebase configuration
  console.log('Firebase initialized');
} else {
  app = getApp();  // Get the existing app instance
  console.log('Firebase already initialized, using existing instance');
}

const db = getFirestore(app);

export const auth = getAuth(app);

export default app

export { db }

// Util to convert Firestore Timestamps to ISO strings,a nd select props to return
export function sanitizeUserData(data: any): UserProfile {
  return {
    uid: data.uid,
    name: data.name,
    activeZoneId: data.activeZoneId,
    createdAt: data.createdAt?.toDate().toISOString(),
    lastSeen: data.lastSeen?.toDate().toISOString(),
  }
}

export async function ensureAnonymousSignIn(): Promise<User> {
  const { user } = await signInAnonymously(auth)
  return user
}

export async function getOrCreateUserRecord(user: User): Promise<any> {
  const userDocRef = doc(db, 'users', user.uid)
  const userDocSnap = await getDoc(userDocRef)

  if (!userDocSnap.exists()) {
    const token = await user.getIdToken()
    await fetch(`${API_URL}users/initUser`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    // Re-fetch the new doc after creating it
    const newDocSnap = await getDoc(userDocRef)
    if (!newDocSnap.exists()) {
      throw new Error('Failed to create user document.')
    }

    return sanitizeUserData(newDocSnap.data()) as UserProfile
  }

  return sanitizeUserData(userDocSnap.data()) as UserProfile
}
